import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { FaChevronLeft } from 'react-icons/fa';
import { toast } from 'react-toastify';
import BuyerRequirementDetailView from '../../components/infrastructureLeasing/BuyerRequirementDetailView';
import { fetchSellerEnquiryBuyerRequirement } from '../../services/infrastructureLeasingListing.service';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/styles/infrastructure_leasing_buyer_requirements.scss';

export default function InfrastructureLeasingSellerBuyerRequirementViewPage() {
  const { listingId: listingIdParam, enquiryId: enquiryIdParam } = useParams();
  const navigate = useNavigate();
  const listingId = listingIdParam == null ? NaN : Number(listingIdParam);
  const enquiryId = enquiryIdParam == null ? NaN : Number(enquiryIdParam);
  const [loading, setLoading] = useState(true);
  const [detail, setDetail] = useState(null);

  useEffect(() => {
    let cancelled = false;
    if (!Number.isFinite(listingId) || listingId < 1 || !Number.isFinite(enquiryId) || enquiryId < 1) {
      setLoading(false);
      return undefined;
    }
    (async () => {
      setLoading(true);
      try {
        const res = await fetchSellerEnquiryBuyerRequirement(listingId, enquiryId);
        if (cancelled) return;
        if (res?.success === false || !res?.data?.form) {
          toast.error(res?.message || 'Requirement not found.');
          navigate(`/infrastructure-leasing/my-properties/${listingId}/enquiries`, { replace: true });
          return;
        }
        setDetail(res.data);
      } catch (e) {
        if (!cancelled) {
          toast.error(e?.response?.data?.message || e?.message || 'Could not load requirement.');
          navigate(`/infrastructure-leasing/my-properties/${listingId}/enquiries`, { replace: true });
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [listingId, enquiryId, navigate]);

  if (!Number.isFinite(listingId) || listingId < 1 || !Number.isFinite(enquiryId) || enquiryId < 1) {
    return (
      <div className="container-fluid py-4 ile-buyer-req">
        <p className="text-muted">Invalid link.</p>
        <Link to="/infrastructure-leasing/my-properties" className="btn btn-dark btn-sm">
          Back to My properties
        </Link>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="container-fluid py-4 ile-buyer-req">
        <p className="text-muted">Loading…</p>
      </div>
    );
  }

  if (!detail) {
    return null;
  }

  return (
    <div className="container-fluid py-4 ile-buyer-req ile-buyer-req-detail">
      <Link
        to={`/infrastructure-leasing/my-properties/${listingId}/enquiries`}
        className="btn btn-link btn-sm text-decoration-none ps-0 mb-2"
      >
        <FaChevronLeft className="me-1" aria-hidden />
        Enquiries for this listing
      </Link>

      <BuyerRequirementDetailView detail={detail} />
    </div>
  );
}
